import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { User } from 'app/classes/user';
import { UserManagementService } from 'app/core/services/user-management.service';
import { debounce } from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'manage-unapproved-users',
  templateUrl: './manage-unapproved-users.component.html',
  styleUrls: ['./manage-unapproved-users.component.scss']
})
export class ManageUnapprovedUsersComponent implements OnInit, OnChanges, OnDestroy {
  @Input() allUsers: User[] = [];
  @Output() userApproved: EventEmitter<User> = new EventEmitter<User>();
  @Output() userDenied: EventEmitter<User> = new EventEmitter<User>();
  isLoading = false;
  queryParams = '';
  userSearchTerm = '';
  unapprovedUsers: User[];
  subscription: Subscription;
  dataSource: MatTableDataSource<User>;
  currentPage: number;
  totalPages: number;
  limitPerPage = 10;
  totalUnapprovedUsers: number;
  sortColumn: string;
  sortDirection: string;
  paginator: MatPaginator;

  private debouncedFetchUsers = debounce(this.buildQueryParamsAndFetchUsers.bind(this), 500);

  displayedColumns: string[] = [
    'registrationTimestamp',
    'lastname',
    'firstname',
    'email',
    'rank',
    'justification',
    'requestedApplication',
    'sponsorEmail',
    'sponsorName',
    'actions'
  ];

  constructor(private userManagementService: UserManagementService,
    private cd: ChangeDetectorRef) {
      this.paginator = new MatPaginator(new MatPaginatorIntl(), this.cd, {});
    }

  ngOnInit(): void {
    this.buildQueryParamsAndFetchUsers();
    this.cd.markForCheck();
  }

  ngOnChanges(): void {

  }

  buildQueryParamsAndFetchUsers(): void {
    console.log(this.userSearchTerm);
    let params = `?search=${this.userSearchTerm}`;
    if (this.currentPage) {
        params += `&pageNumber=${this.currentPage}`;
    }
    if (this.limitPerPage) {
        params += `&limitPerPage=${this.limitPerPage}`;
    }
    if (this.sortDirection) {
        params += `&sort=${this.sortDirection}`;
    }
    if (this.sortColumn) {
        params += `&order=${this.sortColumn}`;
    }
    this.queryParams = params;
    this.fetchUsers();
  }

  fetchUsers(): void {
    this.isLoading = true;
    console.log(this.queryParams);
    this.subscription = this.userManagementService.getUnapprovedUsers(this.queryParams).pipe().subscribe((result: any) => {
      this.unapprovedUsers = <User[]> result.users;
      this.totalUnapprovedUsers = result.total;
      this.currentPage = result.currentPage;
      this.totalPages = result.totalPages;
      this.limitPerPage = result.limitPerPage;
      this.dataSource = new MatTableDataSource<User>(this.unapprovedUsers);
      this.dataSource.paginator = this.paginator;
      this.isLoading = false;
    });
  }

  approve(user: User): void {
    if (user) {
      console.log('uuid', user.uuid);
      this.userManagementService.approveAccountRequest(user.uuid).subscribe(() => {
        console.log('user ' + user.uuid + ' approved');
        this.userApproved.emit(user);
        this.buildQueryParamsAndFetchUsers();
      }, error => {
        console.error(error);
      });
    }
  }

  deny(user: User): void {
    if (user) {
      this.userManagementService.denyAccountRequest(user.uuid).pipe().subscribe(() => {
        console.log('user ' + user.uuid + ' deleted');
        this.userDenied.emit(user);
        this.buildQueryParamsAndFetchUsers();
      }, error => {
        console.error(error);
      });
    }
  }

  onPageEvent($event) {
    console.log('paged event happend', $event);
    if ($event) {
      this.currentPage = $event.pageIndex + 1;
      this.buildQueryParamsAndFetchUsers();
    }
  }

  sortData(sort: MatSort) {
    if (sort && sort.active) {
      this.sortColumn = sort.active;
      this.sortDirection = sort.direction;
    } else {
      this.sortColumn = undefined;
      this.sortDirection = undefined;
    }
    this.buildQueryParamsAndFetchUsers();
    this.cd.markForCheck();
  }

  searchData(): void {
    this.buildQueryParamsAndFetchUsers();
  }

  debounceFetchUsers(): void {
    this.debouncedFetchUsers();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
